import React from "react";

export default function SubHeader() {
  return (
    <div className="no-padding">
      <div
        className="no-animation cmp-container"
        style={{
          backgroundImage: "url(./images/banner-bg-contact-us.svg)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}
      >
        <div className="aem-Grid aem-Grid--12 aem-Grid--default--12  base-print-grid">
          <div className="breadcrumb__wrapper">
            <div
              className="breadcrumb aem-GridColumn aem-GridColumn--default--12 animation-wrapper"
              style={{ height: "auto" }}
            >
              <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 animation-element slide-up animation-display base-print-grid">
                <nav
                  id="breadcrumb-5039d2512d"
                  className="cmp-breadcrumb"
                  aria-label="Breadcrumb"
                  data-cmp-data-layer='{"breadcrumb-5039d2512d":{"@type":"web/components/navigation/breadcrumb","repo:modifyDate":"2021-02-08T06:49:00Z"}}'
                >
                  <ul className="cmp-breadcrumb__list breadcrumb--default breadcrumb--tablet">
                    <li className="cmp-breadcrumb__item">
                      <a
                        href="/member"
                        aria-label="Home"
                        className="cmp-button cmp-button--link"
                        itemProp="item"
                        data-cmp-clickable=""
                        data-analytics-click-id="BreadcrumbsBacklink1"
                        data-analytics-text="Home"
                      >
                        <span itemProp="name" className="cmp-button__text">
                          Home
                        </span>
                      </a>
                      <span className="icons_space icon-dls-arrow-right"></span>
                    </li>

                    <li className="cmp-breadcrumb__item cmp-breadcrumb__item--active">
                      <span itemProp="name" className="cmp-button__text">
                        Contact us
                      </span>
                    </li>
                  </ul>

                  <ol className="cmp-breadcrumb__list breadcrumb--phone">
                    <li className="cmp-breadcrumb__item">
                      <a
                        href="/member"
                        aria-label="Home"
                        data-analytics-click-id="BreadcrumbsBacklink1"
                        data-analytics-text="Home"
                        className="cmp-button cmp-button--link"
                      >
                        <span className="icons_space icon-dls-arrow-left"></span>
                        <span className="cmp-button__text">Home</span>
                      </a>
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          <div
            className="banner aem-GridColumn aem-GridColumn--default--12 animation-wrapper"
            style={{ height: "auto" }}
          >
            <div
              className="mast-head mast-head-section fluid-container animation-element slide-up animation-display"
              role="banner"
            >
              <div className="aem-Grid aem-Grid--default--12 mast-head-container base-print-grid">
                <div className="aem-GridColumn aem-GridColumn--default--8 mast-head-content">
                  <h2
                    className="mast-head-subtitle title__text"
                    aria-label="Subtitle"
                  >
                    Contact us
                  </h2>
                  <div
                    className="mast-head-description"
                    data-external-icon="true"
                  >
                    <p>Find answers to your questions here.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
